import { Stack, Text, Button, Card, styled } from '@/theme/index';

export const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  border: '1px solid #E2E2E2',
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    width: '48%',
    justifyContent: 'space-between',
  },
}));

export const CardsContainer = styled(Stack)(({ theme }) => ({
  gap: '12px',
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
}));

export const ButtonsContainer = styled(Stack)(({ theme }) => ({
  gap: '12px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    paddingRight: '32px',
  },
}));

export const StyledClearAllButton = styled(Button)(({ theme }) => ({
  textDecoration: 'underline',
  display: 'block',
  marginLeft: 'auto',
  color: theme.palette.success.main,
  marginBottom: '20px',
}));

export const StyledNameText = styled(Text)(({ theme }) => ({
  textDecoration: 'underline',
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.spacing(0.5),
}));

export const CheckboxAndTextContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  '.Mui-checked': {
    color: '#81B44C !important',
  },
  [theme.breakpoints.up('sm')]: {
    width: '60%',
  },
}));

export const TextAndTooltipContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.up('sm')]: {
    paddingRight: '20px',
  },
}));
